/* eslint-disable no-shadow */
import React from 'react';

import { Grid, Paper, Radio, Typography } from '@material-ui/core';
import clsx from 'clsx';

import { useStyles } from './styles';

import { usePartner } from '../../context/PartnerContext';
import * as session from '../../utils/session';
import ReactGTM from '../../utils/gtm';
import CustomButton from '../CustomButton/CustomButton';

export const TIPO_ENVIO = {
  EMAIL: 'email',
  SMS: 'sms',
};

function Option({
  isPrimeiroAcesso,
  celular,
  tipoEnvio,
  data,
  handleSelectCard,
  selectedCard,
  labelEmail,
  labelSms,
}) {
  const classes = useStyles({ isPrimeiroAcesso });
  const selected = Boolean(selectedCard === tipoEnvio);
  const showRadio = Boolean(celular || isPrimeiroAcesso);

  const text =
    tipoEnvio === TIPO_ENVIO.EMAIL ? labelEmail : labelSms;

  return (
    <Grid container justifyContent="center" className={classes.container}>
      <Grid
        item
        component={Paper}
        square
        elevation={0}
        className={clsx(classes.root, selected && classes.selected)}
        onClick={handleSelectCard}
      >
        <Grid container justifyContent="flex-start" alignContent="center">
          <Grid container item xs={2} alignContent="flex-start">
            {showRadio && (
              <Radio
                style={{ padding: '0 9px' }}
                color="primary"
                checked={selected}
              />
            )}
          </Grid>

          <Grid xs={10} container item justifyContent="flex-start">
            <Grid xs={12} container item justifyContent="flex-start">
              <Typography
                className={clsx(
                  classes.titleCard,
                  isPrimeiroAcesso && selected && classes.titleCardSelected,
                  !isPrimeiroAcesso && selected && classes.selected,
                )}
              >
                {text}
              </Typography>
            </Grid>
            <Grid xs={12} container item justifyContent="flex-start">
              <Typography title={data} className={classes.divData}>
                {data}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default function SelectOption({
  email,
  celular,
  onSubmitSelectCard,
  isPrimeiroAcesso,
}) {
  const classes = useStyles({ isPrimeiroAcesso });
  const { screens } = usePartner();
  const wlTexts = screens.selecaoEnvioCodigoPrimeiroAcesso?.texts;
  const labelEmail = isPrimeiroAcesso
    ? wlTexts.labelEmail
    : 'Receber por e-mail:';
  const labelSms = isPrimeiroAcesso ? wlTexts.labelSms : 'Receber por SMS:';
  const buttonText = isPrimeiroAcesso ? wlTexts.button : 'Enviar';

  const [selectedCard, setSelectedCard] = React.useState(
    celular ? null : 'email',
  );

  const isChabot = session.getChatbot();
  const tagId = isChabot
    ? 'continuar-acesso-whats-001'
    : 'continuar-acesso-001';

  const handleSelectCard = (value) => {
    if (value === selectedCard && celular) {
      setSelectedCard(null);
    } else {
      setSelectedCard(value);
    }

    //* * Google Analytics */
    ReactGTM.event({
      event: 'auto.event',
      ev_action: 'selecionou:receber-codigo',
      ev_label: value,
    });
  };

  const defaultOptionProps = {
    isPrimeiroAcesso,
    celular,
    selectedCard,
    labelEmail,
    labelSms,
  };

  return (
    <>
      <Option
        {...defaultOptionProps}
        tipoEnvio="email"
        data={email}
        handleSelectCard={() => handleSelectCard('email')}
      />

      {celular && (
        <Option
          {...defaultOptionProps}
          tipoEnvio="sms"
          data={celular}
          handleSelectCard={() => handleSelectCard('sms')}
        />
      )}
      <Grid container>
        <CustomButton
          content={buttonText}
          className={classes.button}
          onClickCallBack={() => onSubmitSelectCard(selectedCard)}
          disabled={Boolean(!selectedCard)}
          gtm={{
            id: tagId,
            'data-gtm-name': 'continuar',
          }}
        />
      </Grid>
    </>
  );
}
